import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {DisposalTypesActions} from '../store';
import {DisposalTypesSelectors} from '../store/selectors';

@Injectable()
export class DisposalTypesLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadDisposalTypesDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadDisposalTypesDone() {

    return this.store.pipe(
      select(DisposalTypesSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(DisposalTypesActions.ReadDisposalTypes());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
